import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { RewardService } from 'src/app/services/reward.service';

@Component({
  selector: 'app-list-premios',
  templateUrl: './list-premios.component.html',
  styleUrls: ['./list-premios.component.css']
})
export class ListPremiosComponent implements OnInit {

  eventsSubject: Subject<any> = new Subject<any>();


  displayedColumns: string[] = ['name', 'store', 'rewardType','startDate', 'endDate', 'status', 'actions'];
  columnsToDisplay = [{field: 'name', header: 'Nome', type: 'text'}, {field: 'startDate', header: 'Data ínicio', type: 'date'}, {field: 'endDate', header: 'Data Fim', type: 'date'}];
  columnsObject = [{field: 'store', object:'store', subObject:'name', header: 'Loja', type: 'select', selectFieldsDados: []},
  {field: 'rewardType', object:'rewardType', subObject:'name', header: 'Tipo', type: 'select', selectFieldsDados: []}];
    columnsBadge = [{field: 'status', header: 'Estado', type: 'select', selectFieldsDados:  [ {name: 'Ativo', val: 'ACTIVE'}, {name: 'Inativo', val: 'INACTIVE'}]}];
    options = {edit: true, view: true, delete: true, statusUpdate: true};
  title = 'Prémios';
  novo = {link: '/premios/criar', nome: 'Novo Prémio'};
  page: any = {base: null, name: null};
  service;

  constructor(private storeService: StoreService,
    private route: ActivatedRoute,
    private rewardService: RewardService,
    private confirmationDialogService: ConfirmationDialogService,
    private toast: ToastrService,
    private router: Router,) {
this.service = this.rewardService.getAll;
this.storeService.getAll(null).pipe(first())
      .subscribe(
          data => {
            console.log('lojas', data);
            this.columnsObject[0].selectFieldsDados = data['content'];
          },
          error => {
            console.log('error', error);
        });
        this.rewardService.getAllTypes(null).pipe(first())
      .subscribe(
          data => {
            console.log('tipos', data);
            this.columnsObject[1].selectFieldsDados = data['content'];
          },
          error => {
            console.log('error', error);
        });
}

ngOnInit(): void {
  this.page.base = this.route.data['value'].base;
  this.page.name = this.route.data['value'].routeName;
  }

  edit = (args: any): void => {
    console.log(args);
    this.router.navigate([this.page.base  + '/editar'], { queryParams: { id: args.id } });
    }
    view = (args: any): void => {
      console.log(args);
      this.router.navigate([this.page.base  + '/view'], { queryParams: { id: args.id } });
    }
    changeStatus = (args: any): void => {
    let textConfirm = '';
    let status = '';
    let textShow = '';

    let service;
    if (args.status === 'ACTIVE'){
      service = this.rewardService.inactive(args.id);
      textConfirm = 'Pretende Desactivar o Prémio ' + args.name + '? Ao desactivar o Prémio o estado do Prémio será alterado para INATIVO.';
      status = 'INACTIVE';
      textShow = 'PRÉMIO DESATIVADO COM SUCESSO';
    }
    else{
      service = this.rewardService.active(args.id);
      textConfirm = 'Pretende Activar o Prémio ' + args.name + '? Ao activar o Prémio o estado do Prémio será alterado para ATIVO';
      status = 'ACTIVE';
      textShow = 'PRÉMIO ACTIVADO COM SUCESSO';
    }

    this.confirmationDialogService.confirm('Por favor confirme', textConfirm)
    .then((confirmed) =>
    {
      if (confirmed){
        service.subscribe((event: any) => {
          this.toast.warning(textShow, 'Mudança de Estado');
          args.status = status;
      });
      }
    }
    )
    .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

    delete = (total: any, args: any, index: number): void => {
      this.confirmationDialogService.confirm('Por favor confirme', 'Pretende apagar este Prémio ' + args.name + '? Ao eliminar os dados do Prémio serão perdidos!!')
      .then((confirmed) =>
      {
        if (confirmed){
          const indexo = total.indexOf(args);
          this.rewardService.delete(args.id).pipe(first())
      .subscribe(
          data => {
            this.toast.warning('Eliminado com sucesso', 'Delete');
            total.splice(indexo, 1);
            console.log('total', total);
            this.eventsSubject.next(total);
          },
          error => {
              console.log('error', error);
          });
        }
      }
      )
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
      console.log(args);
    }

  }
